export const operations = {
  add: "ADD",
  decrease: "DECREASE",
};

export const MOBILE_BREAKPOINT = 940;
